<template>
	<v-card>
		<v-card-title>账户编辑</v-card-title>
		<v-card-subtitle v-if="form.balance">{{ form.balance }}</v-card-subtitle>
		<v-card-text>
			<v-row>
				<v-col cols="12" sm="6">
					<v-text-field
						label="名称*"
						placeholder=""
						v-model="form.name"
						:error-messages="errors.name"
						required
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field
						label="编码*"
						placeholder=""
						v-model="form.code"
						:error-messages="errors.code"
						required
					></v-text-field>
				</v-col>

				<v-col cols="12">
					<v-radio-group v-model="form.type" label="类型" inline :error-messages="errors.type">
						<v-radio
							v-for="(l, k) in options['ShopAccountType']"
							:value="l.value"
							:label="l.title"
							:key="k"
						></v-radio>
					</v-radio-group>
				</v-col>
				<v-col cols="12" sm="6">
					<v-radio-group v-model="form.status" label="状态" inline :error-messages="errors.status">
						<v-radio
							v-for="(l, k) in options['ShopAccountStatus']"
							:value="l.value"
							:label="l.title"
							:key="k"
						></v-radio>
					</v-radio-group>
				</v-col>
				<!-- <v-col cols="12">
                        <uploader class="d-inline-block" @uploaded="onImgUploaded" accept="image/*">
                            <v-btn color="primary">上传图标</v-btn>
                        </uploader>
                        <v-text-field v-model="form.icon"></v-text-field>
                        <v-img v-if="form.icon" :src="form.icon" aspect-ratio="1" contain max-height="100"
                            max-width="100">
                        </v-img>
                    </v-col>
                    <v-col cols="6">
                        <v-subheader>背景色</v-subheader>
                        <color-picker v-model="form.color"></color-picker>
                    </v-col> -->

				<v-col cols="12">
					<v-text-field
						label="备注"
						placeholder=""
						v-model="form.memo"
						:error-messages="errors.memo"
						required
					></v-text-field>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<slot name="actions" v-bind:object="form"></slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import ColorPicker from '../common/ColorPicker.vue'
import Uploader from '../common/Uploader.vue'
import { clone } from 'lodash-es'

export default {
	components: { Uploader, ColorPicker },
	props: {
		value: {
			type: Object,
			default: () => {
				return {}
			}
		},
		errors: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data: () => ({
		form: {},
		options: {}
	}),
	watch: {
		// value: {
		// 	handler: function (nv, oldVal) {
		// 		this.form = clone(nv)
		// 	},
		// 	deep: true
		// }
	},
	mounted() {
		this.form = clone(this.value)
		this.$api.common.meta('Shop', 'ShopAccountStatus,ShopAccountType', (r) => {
			this.options = r
		})
	},
	methods: {
		onColorPicked(c) {
			if (typeof c === 'object') {
				this.form.color = c.hexa
			} else {
				this.form.color = c
			}
		},
		onImgUploaded(files) {
			this.form.icon = files[0]
		},
		clear() {
			this.form = {}
		}
	}
}
</script>
